"use strict";
/**
 * Main Class and namespace
 * @class Proj
 * @singletone
 */
var Proj = (function(proj) {
	proj.interfaceName = '';

  proj.init;

	proj.init = function() {
		proj.interfaceName = $('body').data("interfaceName");
	};

	return proj;

})(Proj || {});

/** @type {String} url для ajax запроса */
var AJAX_URI = '/json/';

/** @type {String} id сессии из командной строки */
var SESS_ID = '';
if (window.location.toString().match(/SESS_ID=(\d+)/))
	SESS_ID = RegExp.$1;
//------------------------------------------------------------------------------
/* @param {Function} handler Обработчик */
Proj.getJSON = function(data, handler) {
	if (SESS_ID)
		data['SESS_ID'] = SESS_ID;
	$.post(AJAX_URI, data, handler, 'json');
}

/**
  *  Обработчик fancybox
  */
Proj.FancyBox = function(){
	$(".fancy").fancybox({});
}

/**
  *  Обработчик Слайдера
  */
Proj.Slider = function(selector, params){
    var prevWidth = $(window).width();
	$(selector).slick(params);
    $(window).on('resize', function(){
        var width = $(window).width();
        if(width < 1100 && prevWidth > 1100) {
            $(selector).slick(params);
        }
        prevWidth = width;
    });
}
//------------------------------------------------------------------------------
Proj.initMain = function() {

    var products = [];
    var $items = $('.btn-buy');
    $items.each(function(i){
        products.push({
            "id": $items.eq(i).data('productId'),
            "name" : $items.eq(i).data('name'),
        });
    });
    if ($items.length>0) {
        dataLayer.push({
            "ecommerce": {
                "detail": {
                    "products": products
                }
            }
        });
    }
    //$('a.btn-buy, a.btn-del, .btn-basket .badge').tooltip();
    $('.prod_page .table').wrap('<div class="table-responsive"></div>');

    var hash = window.location.hash;
    if (hash != '') {
        if ($(hash+'.panel-heading').length > 0) {
            $(hash).next('div').addClass('in');
        } else {
            $(hash).parents('.panel-collapse').addClass('in');
        }
        $('body, html').animate({ scrollTop: $(hash).offset().top - 55}, 600);
    }
    $('.js-scroll-to').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('body, html').animate({ scrollTop: $(target).offset().top - 55}, 600);
    });
    var $body = $("html, body");
    var $mlogo = $(".header-block");
    var $smenu = $(".header");
    var $slogo = $(".navbar-brand");
    var $rmenu = $(".js-menu-right");

    var offsetTop = $("#top").offset().top;
    var offsetFooter = $("#bottom").offset().top;
    var wHeight = window.innerHeight;
    var lHeight = $mlogo.outerHeight();
    if ($rmenu.length > 0) { var rtop = $rmenu.offset().top; }

    $('.we-block-slider').owlCarousel({
        nav: true,
        navText: [],
        navClass: ['owl-prev','owl-next'],
        loop: true,
        //center: true,
        autoplay: false,
        autoplaySpeed: 1000,
        startPosition: 0,
        responsive : {
            0 : { loop: true, items: 1 },
            480 : { loop: true, items: 2 },
            768 : { loop: true, items: 3 },
            992 : { loop: true, items: 3 },
            1200 : { loop: true, items: 4 },
            1600 : { loop: false, items: 4 },
        },
    });

    $('.gallery').owlCarousel({
        nav: true,
        navText: [],
        navClass: ['owl-prev','owl-next'],
        loop: true,
        //center: true,
        autoplay: false,
        autoplaySpeed: 1000,
        startPosition: 0,
        items: 3,
    });

    _initScroll();

    function _initScroll() {
        var $topLink = $(".on-top").click(function(e) {
            $body.animate({ scrollTop: 0 }, 600);
            return false;
        });

        $('[data-toggle="popover"]').popover({
            html: true,
            content: function() {
                return $(this).find('.hidden').html();
            },
        });

        function _scrollHandler(e) {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (lHeight >= scrollTop) {
                $smenu.css('margin-top', 0+'px');                if ($body.width() > 767) {
                    $slogo.fadeOut();                } else {
                    $slogo.fadeIn();
                }
            } else {
                $smenu.css('margin-top', (scrollTop-lHeight)+'px');
                $slogo.fadeIn();
            }

            if (scrollTop > lHeight) {
                $topLink.fadeIn();
                if (scrollTop+wHeight > offsetFooter) {
                    var y = scrollTop + wHeight - offsetFooter;
                    $topLink.css('bottom', y+'px !important');
                } else {
                    $topLink.css('bottom', 0+'px !important');
                }
            } else {
                $topLink.fadeOut();
            }
            if ($body.width() > 979 && $rmenu.length > 0) {
                if (scrollTop > rtop) {
                    $rmenu.next().fadeIn();
                    var t = scrollTop - rtop + lHeight;
                    $rmenu.next().css('margin-top', t+'px');
                } else {
                    $rmenu.next().fadeOut();
                    $rmenu.next().css('margin-top', 0);
                }
            }
        };

        $(window).on('scroll', _scrollHandler);
        _scrollHandler();
    }
}
//------------------------------------------------------------------------------
Proj.Modal = function() {
    $('#modal').on('show.bs.modal', function (e) {
       	$('#modal .modal-title').text('');
    	$('#modal .modal-body').html('');
        if (e.relatedTarget) {;
            var class_name = e.relatedTarget.dataset.class_name
            var object_id = e.relatedTarget.dataset.object_id
            var programm_id = e.relatedTarget.dataset.programm_id
            var style = e.relatedTarget.dataset.style;
        } else {
            var class_name = 'basket_one_click';
            var style = 'modal-lg';
        }
        $('#modal .modal-dialog').addClass(style);
        Proj.getJSON( { '_do': 'get_'+class_name, 'object_id': object_id, 'programm_id': programm_id }, function(data) {
            $('#modal .modal-title').html(data.title);
            $('#modal .modal-body').html(data.html);
            if (class_name=='page_with_form') {
            		var $form = $('#modal .modal-body').find('form');
            		$form.ajaxForm({
            			beforeSend: function(){
            				$form.find(".has-error").removeClass("has-error");
            			},
            			success: function(e){
            				answer(e);
            			},
            			error: function(e){
            			},
                        type: 'POST',
            			dataType: 'json',
            			url: '/json/',
            			data: { _do: 'submit_form' }
            		});
      			}
            if (class_name=='basket_one_click') {
                basketIface = 'one_click';
                Order.init({
                    basketBlockSelector : '#basket-block',
                    basketButtonsSelector : '.btn-buy',
                    basketTableSelector : '#basket-table',
                    basketCheckout : '#basket-checkout'
                });
      			}
        });
      	function answer(json) {
      		var $form = $('#modal .modal-body').find('form');
          if ($form.hasClass('form-form_question')) {
              Proj.yaReachGoal('39512360', 'form_question_send');
          }
    		if(json.status=="ok"){
      			if(json.errors){
    				for(var i=0;i<json.errors.length;i++){
      					var attr = ".attr-"+json.errors[i];
      					$form.find(attr).addClass("has-error");
    				}
      			}else{
    				var $cblock = $('#modal .modal-body');
    				$cblock.html(json.content);
      			}
    		}
  	    }
        $('#modal').on('hidden.bs.modal', function (e) {
            $('#modal .modal-dialog').removeClass(style);
            if (class_name=='basket_one_click') {
                window.location.reload();
            }
        });
    });
}


Proj.blockPrint = function(selector) {
    $(selector).on('click', function(e){
        e.preventDefault();
        window.print();
        //var id = $(this).data('id');
        //var file = $(this).data('file');
        //if (file != '') {
        //    printJS(file, 'pdf');
        //} else {
        //    printJS({ printable: id, type: 'html', font_size: '14pt', maxWidth: 1400 });
        //}
    });
}



Proj.blockMap = function(selector) {
    $(selector).each(function(index) {
        var height = $(selector).eq(index).siblings().height();
        $(selector).eq(index).height(height-20);
        var address = $(selector).eq(index).data('address');
        var id = $(selector).eq(index).attr('id');
        ymaps.ready(function(){
            var myMap = new ymaps.Map(id, {
                center: [0, 0],
                zoom: 9
            });
            ymaps.geocode(address, {
                results: 1
            }).then(function (res) {
                    var firstGeoObject = res.geoObjects.get(0),
                        coords = firstGeoObject.geometry.getCoordinates(),
                        bounds = firstGeoObject.properties.get('boundedBy');
        
                    firstGeoObject.options.set('preset', 'islands#darkBlueDotIconWithCaption');
                    firstGeoObject.properties.set('iconCaption', firstGeoObject.getAddressLine());
        
                    myMap.geoObjects.add(firstGeoObject);
                    myMap.setBounds(bounds, {
                        checkZoomRange: true
                    });
                });
        });
    });

}

Proj.prodFilter = function(selector) {
    console.log('Init Filter');
    var $search = $(selector).find('input');
    var $tables = $(selector+'-table');
    var $prods = $(selector+'-item td:first-child');
    $prods.each(function(){
        var group_name = $(this).parents('tbody').find('h2').text();
        var subgroup_name = '';
        if ($(this).parent().data('subgroup')) {
          var subgroup = $(this).parent().data('subgroup');
          subgroup_name = $(this).parent().siblings('[data-id='+subgroup+']').find('h3').text();
        }
        var item_name = $(this).text();
        $(this).attr('data-name', group_name+' '+subgroup_name+' '+item_name);
    });
	if ($search.length) {
		$search.val('').keyup();
		//notFound.hide();
		$search.keyup(function() {
			var query = $(this).val();
      var id = $(this).parents(selector).data('table');
			$(id).find(selector+'-item td:first-child').each(function() {
				if (!$(this).attr('data-name').match(new RegExp('.*?' + query + '.*?', 'i'))) {
					$(this).parent().hide();
				} else {
					$(this).parent().show();
          $(this).parents(selector+'-group').show();
          if ($(this).parent().data('subgroup')) {
            var subgroup = $(this).parent().data('subgroup');
            $(this).siblings('[data-id='+subgroup+']').show();
          }
				}
			});
      $(id).find(selector+'-group').each(function() {
  			if ($(this).find(selector+'-item:visible').length < 1) {
          $(this).hide();
        } else {
          $(this).show();
        }          
      });
      $(id).find(selector+'-subgroup').each(function() {
        var subgroup = $(this).data('id');
  			if ($(selector+'-item:visible[data-subgroup='+subgroup+']').length < 1) {
          $(this).hide();
        } else {
          $(this).show();
        }          
      });
			//if ($prods.filter(':visible').length < 1) {
				//notFound.show();
			//} else {
				//notFound.hide();
			//}
		});
    $(selector+'-clear').on('click', function(){
			$(this).parents(selector).find('input').val('').keyup();
    });
	}
}

//------------------------------------------------------------------------------
Proj.yaReachGoal = function(counterId, goalName) {
    var counterName = 'yaCounter' + counterId;
    var counter = window[counterName];
    //console.log(counter);
    if (typeof counter !== 'undefined') {
        console.log('reachGoal ' + goalName);
        counter.reachGoal(goalName);
    } else {
        var count = 0;
        var timerId = setInterval(function() {
            count++;
            // console.log('count = ' + count);
            var counter = window[counterName];
            // console.log(counter);
            if (typeof counter !== 'undefined') {
                console.log('reachGoal ' + goalName);
                counter.reachGoal(goalName);
                // console.log('goal reached => clearInterval');
                clearInterval(timerId);
            }
            if (count > 2) {
                // console.log('count = 3 => clearInterval');
                clearInterval(timerId);
            }
        }, 1000);
    }
}
